import axios from "axios";
import appConfig from "@/configs/app.config";
import VueCookies from 'vue-cookies'
import router from '@/router';
import {useDataStore} from "@/stores/data.store";
const axiosInstance = axios.create({
    baseURL: appConfig.APP_API,
    headers: {
        "Content-Type": "application/json"
    }
});

axiosInstance.interceptors.request.use((config) => {
    const token = VueCookies.get('access_token')
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Add a response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
    async (response) => {
        if(response.data.version > localStorage.getItem("version")){
            const dataStore = useDataStore();
            await dataStore.initializeData(1);
        }
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // If the error is 401 and we haven't retried yet
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Attempt to refresh the token
                const refreshToken = VueCookies.get('refresh_token');
                const response = await axios.post(`${appConfig.APP_API}auth/refresh`, {
                    refresh_token: refreshToken,
                });
              

                const newAccessToken = response.data.accessToken;
                console.log(newAccessToken, response.data)
                // Update the token in cookies
                VueCookies.set('access_token', newAccessToken);

                // Update the Authorization header
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                console.error("888");
                // Retry the original request
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                // If refreshing fails, redirect to login or clear auth state
                alert("Axiso")
                VueCookies.remove('access_token');
                VueCookies.remove('refresh_token');
                const loginRoute = router.resolve({ name: 'login' });
                window.location.href = loginRoute.href+"?next="+window.location.href;
                
                return Promise.reject(error);

                
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;